import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, CalendarIcon } from 'lucide-react';
export function ConditionsSection() {
  const categories = [{
    title: 'Pain Conditions',
    conditions: ['Muscle pain', 'Joint pain', 'Back pain', 'Neck pain', 'Shoulder pain', 'Minor arthritis pain & stiffness']
  }, {
    title: 'Foot & Ankle',
    conditions: ['Plantar fasciitis', 'Achilles tendonitis', 'Foot & ankle pain', 'Neuropathy / neuroma']
  }, {
    title: 'Recovery & Rehab',
    conditions: ['Post-surgical recovery', 'Sports injuries', 'Fractures', 'Edema / swelling']
  }, {
    title: 'Mobility & Function',
    conditions: ['Poor range of motion', 'General recovery support', 'Muscle spasms', 'Stiffness']
  }];
  return <section className="py-20 md:py-28 bg-brand-teal relative overflow-hidden" data-id="element-27">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl pointer-events-none" data-id="element-28" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-navy/10 rounded-full blur-3xl pointer-events-none" data-id="element-29" />

      <div className="container mx-auto px-4 max-w-7xl relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-31">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-32">
            What Can Aspen Laser Therapy Help Support?
          </h2>
          <p className="text-lg text-teal-50" data-id="element-33">
            Laser therapy is a versatile modality used to address a wide variety
            of acute and chronic conditions by targeting the underlying cellular
            dysfunction.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-34">
          {categories.map((category, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6" data-id="element-35">
              <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2 border-b border-white/20 pb-4" data-id="element-36">
                <ActivityIcon className="w-5 h-5 text-teal-200" data-id="element-37" />
                {category.title}
              </h3>
              <ul className="space-y-3" data-id="element-38">
                {category.conditions.map((condition, cIdx) => <li key={cIdx} className="flex items-start gap-2 text-teal-50" data-id="element-39">
                    <div className="w-1.5 h-1.5 rounded-full bg-teal-300 mt-2 flex-shrink-0" data-id="element-40" />
                    <span className="leading-tight" data-id="element-41">{condition}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center text-center" data-id="element-42">
          <p className="text-teal-100 text-sm mb-8 max-w-2xl italic" data-id="element-43">
            * Note: Suitability for laser therapy depends on the patient's
            specific condition and a thorough provider assessment. Not all
            conditions respond equally to treatment.
          </p>
          <button className="px-8 py-4 bg-white hover:bg-gray-50 text-brand-teal rounded-lg font-bold text-lg transition-all duration-300 inline-flex items-center justify-center gap-2 shadow-xl" data-id="element-44">
            <CalendarIcon className="w-5 h-5" data-id="element-45" />
            Find Out If Laser Therapy Is Right For You
          </button>
        </motion.div>
      </div>
    </section>;
}